module.exports = __webpack_public_path__ + "static/media/eclipse.2b0ba627.svg";